export default __webpack_public_path__ + "static/media/btn_moodBad.f0365b2a.png";